import { Component, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { DialogResult } from '@progress/kendo-angular-dialog';
import { FileRestrictions } from '@progress/kendo-angular-upload';
import { CustomDialogSettings } from 'src/app/shared/model/CustomDialogSettings';
import { ReferenceType } from 'src/app/shared/model/ReferenceType';
import { CustomDialogService } from 'src/app/shared/services/custom-dialog.service';
import { FileTypeService } from 'src/app/shared/services/file-type.service';
import { ClaimMovieDocumentInfo } from '../../models/ClaimMovieDocumentInfo';
import { DocumentInfo } from '../../models/DocumentInfo';
import { UploadDocumentParameters } from '../../models/UploadDocumentParameters';
import { UploadFilesSettings } from '../../models/UploadFilesSettings';
import { DocumentService } from '../../service/document.service';
import { ShowDocumentComponent } from '../show-document/show-document.component';

@Component({
  selector: 'app-claim-movies2',
  templateUrl: './claim-movies2.component.html',
  styleUrls: ['./claim-movies2.component.scss']
})
export class ClaimMovies2Component implements OnInit {

  constructor(
    private fileTypeService : FileTypeService,
    private documentService: DocumentService,
    private customDialogService : CustomDialogService
  ) { }

  @Input() documentTypeId:number;
  @Input() claimIdentifier:string;
  @Input() extraReferenceId = '';
  @Input() extraReferenceType = 0;

    isLoading: boolean;
    claimMovies: ClaimMovieDocumentInfo[];
    uploadFilesSettings: UploadFilesSettings;
    
    

    @ViewChild("movieContent", { read: ViewContainerRef })
    public containerRef: ViewContainerRef;
    
  ngOnInit(): void {


    const moviesRestrictions: FileRestrictions = {
      allowedExtensions: this.fileTypeService.movie_extensions,
      maxFileSize: 200971520
    };

    const uploadDocumentParameters: UploadDocumentParameters =  {
      documentTypeId: this.documentTypeId,
      referenceType: ReferenceType.Claim,
      referenceId: this.claimIdentifier.toString(),
      extraReferenceType: this.extraReferenceType,
      extraReferenceId: this.extraReferenceId,
      claimIdentifier: this.claimIdentifier,
      otherDocumentKindName : '',
      description: '',
      proofDocumentIds: []
    }

    this.uploadFilesSettings = {
      uploadDocumentParameters :  uploadDocumentParameters,
      fileRestrictions: moviesRestrictions,
      showDocumentDataDialog: false,
      showTopButtons:true,
      autoUpload : false,
      documentDataDialogContent: null
    };

    this.getClaimMovies();
   
  }

  getClaimMovies(){
    this.isLoading = true;
    this.documentService.getClaimMovies( this.claimIdentifier,this.documentTypeId, this.extraReferenceType, this.extraReferenceId ).subscribe(
       (res) => { 
         this.isLoading = false;
         this.claimMovies = res;
        } );
  }

  showContent(documentInfo:DocumentInfo){

    const dialogSettings: CustomDialogSettings = {
      content: ShowDocumentComponent,
      title: documentInfo.name,
      appendTo: this.containerRef,
      maxHeight: '98vh',
       maxWidth: '98vw',
      dialogInputs: {
        documentInfo : documentInfo
      },
      resultCallback: (r: DialogResult) => { }
    };

    this.customDialogService.showDialog(dialogSettings);

  }

  newUploadedItem(ev:any){
    this.getClaimMovies();
  }

}
